import { render } from "./MenuInfo.vue?vue&type=template&id=fabfc20a&scoped=true"
import script from "./MenuInfo.vue?vue&type=script&lang=js"
export * from "./MenuInfo.vue?vue&type=script&lang=js"

import "./MenuInfo.vue?vue&type=style&index=0&id=fabfc20a&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fabfc20a"]])

export default __exports__